import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * cn — Tailwind-aware classname merge. Last-class-wins for conflicting
 * utilities (e.g. `cn("p-2", "p-4")` → `"p-4"`).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** errText extrahiert eine anzeigbare Fehlermeldung aus einem unknown-Fehler. */
export function errText(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}
